















import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { getHours } from '@/utlitities/helper';
import StInput2 from '@/components/basic/StInput2.vue';
import StTimePicker from '@/components/basic/StTimePicker.vue';

@Component({
  components: {
    StInput2,
    StTimePicker
  },
})
export default class StDurationPicker extends Vue {
  @Prop() value!: number;
  @Prop() focus!: boolean;
  @Prop() disabled!: boolean;

  get durationHours(): string {
    return getHours(this.value);
  }

  set durationHours(data: string){
    this.$emit('input', this.getDurationMinutes(data))
  }

  async mounted() {
    if (this.focus) {
      await this.$nextTick();
      setTimeout(() => {
        if (this.focus && (window.innerWidth > 960))
          (this.$refs.inputfield as HTMLInputElement).focus();
      }, 200);
    }
  }

  getDurationMinutes(timeString: string){
    let hours;
    let minutes;
    let durationMinutes;

    if(timeString.length == 4 || timeString.length == 3){
      if(parseInt(timeString) > 100){
        if(timeString.length == 3){
          timeString='0'+timeString;
        }

        timeString = timeString.slice(0,2)+':'+timeString.slice(2);
        
      }
    }

    if (timeString.indexOf(':') > -1) {
      hours = timeString.split(':')[0];
      minutes = timeString.split(':')[1];

      let isNegative = timeString.indexOf('-') === 0;

      durationMinutes = Math.abs(parseInt(hours)) * 60 + parseInt(minutes);

      if (isNegative) durationMinutes = durationMinutes * -1;
    } else {
      let time = parseFloat(timeString.replace(',', '.'));

      durationMinutes = Math.floor(time) * 60 + Math.round((time % 1) * 60);
    }

    this.$forceUpdate();

    if (!durationMinutes) {
      return 0;
    }

    return durationMinutes;
  }

  @Emit('input')
  input(ev: any) {
    let timeString = ev.target.value;

    return this.getDurationMinutes(timeString);
  }
}
